import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <ol>
              <li>
                <p>
                  Adhikari, S., &amp; Southworth, J. (2012). Simulating Forest
                  Cover Changes of Bannerghatta National Park Based on a
                  CA-Markov Model: A Remote Sensing Approach.{" "}
                  <em>Remote Sensing</em>, <em>4</em>(10), 3215&ndash;3243.
                  doi:10.3390/rs4103215
                </p>
              </li>
              <li>
                <p>
                  Agapiou, A, Diofantos H, and Dimitrios A. (2012). Evaluation
                  of Broadband and Narrowband Vegetation Indices for the
                  Identification of Archaeological Crop Marks.{" "}
                  <em>Remote Sensing</em> 4(12): 3892&ndash;3919..
                  <em> Remote Sensing</em>, <em>4</em>(12), 3892&ndash;3919.
                  doi: 10.3390/rs4123892
                </p>
              </li>
              <li>
                <p>
                  Arsanjani, J. J., Marco, H., &amp; Noronha Vaz, E. (2013).
                  Spatiotemporal simulation of urban growth patterns using
                  agent-based modeling: The case of Tehran. <em>Cities</em>,{" "}
                  <em>32</em>, 33&ndash;42. doi:10.1016/j.cities.2013.01.005
                </p>
              </li>
              <li>
                <p>
                  Bharath, H. A., Chandan, M. C., Vinay, S., &amp; Ramachandra,
                  T. V. (2018). Urbanisation in India: Patterns, Visualisation
                  of Cities and Greenhouse Gas Inventory for Developing an Urban
                  Observatory. In Q. Weng, D. Quattrochi, &amp; P. E. Gamba
                  (Eds.), <em>Urban Remote Sensing</em> (2nd ed.). Boca Raton:
                  CRC Press : Taylor and Francis.
                  https://www.taylorfrancis.com/books/9780429888564
                </p>
              </li>
              <li>
                <p>
                  Bharath, H. A., &amp; Ramachandra, T. V. (2016). Visualization
                  of Urban Growth Pattern in Chennai Using Geoinformatics and
                  Spatial Metrics.{" "}
                  <em>Journal of the Indian Society of Remote Sensing</em>,{" "}
                  <em>44</em>(4), 617&ndash;633. doi:10.1007/s12524-015-0482-0
                </p>
              </li>
              <li>
                <p>
                  Bharath, H. A., Vinay, S., Durgappa, D. S., &amp; Ramachandra,
                  T. V. (2013). Modeling and Simulation of Urbanisation in
                  Greater Bangalore. In{" "}
                  <em>
                    National Spatial Data Infrastructure , NSDI 2013 -IIT Bombay
                  </em>
                  . Bombay.
                  http://wgbis.ces.iisc.ac.in/energy/water/paper/iitm_urbanisation/method.htm
                </p>
              </li>
              <li>
                <p>
                  Bharath, H. A., Vinay, S., &amp; Ramachandra, T. V. (2016).
                  Agent Based Modelling Urban Dynamics of Bhopal, India.{" "}
                  <em>Journal of Settlements and Spatial Planning</em>,{" "}
                  <em>7</em>
                  (1), 1&ndash;14. doi:10.19188/01JSSP012016
                </p>
              </li>
              <li>
                <p>
                  Bharath, H. A., Vinay, S., Venugopal Rao, K., &amp;
                  Ramachandra, T. V. (2015). Prediction of spatial patterns of
                  urban dynamics in Pune, India. In{" "}
                  <em>
                    11th IEEE India Conference: Emerging Trends and Innovation
                    in Technology, INDICON 2014
                  </em>
                  . doi:10.1109/INDICON.2014.7030404
                </p>
              </li>
              <li>
                <p>
                  Bharath, H. A, Vinay, S.,&amp; Ramachandra, T. V., (2014),
                  Landscape dynamics modeling through integrated Markov,
                  Fuzzy-AHP and cellular automata, In{" "}
                  <em>2014 IEEE Geoscience and Remote Sensing Symposium</em>,
                  3160-3163, doi: 10.1109/IGARSS.2014.6947148
                </p>
              </li>
              <li>
                <p>
                  Bharath, S., Rajan, K. S., &amp; Ramachandra, T. V. (2014).
                  Status and future transition of rapid urbanizing landscape in
                  central Western Ghats - CA based approach.{" "}
                  <em>
                    ISPRS Annals of the Photogrammetry, Remote Sensing and
                    Spatial Information Sciences
                  </em>
                  , <em>2</em>(8), 69&ndash;75.
                  doi:10.5194/isprsannals-II-8-69-2014
                </p>
              </li>
              <li>
                <p>
                  Brown, D. G., Robinson, D. T., An, L., Nassauer, J. I.,
                  Zellner, M., R &amp;, W., et al. (2008). Exurbia from the
                  bottom-up: Confronting empirical challenges to characterizing
                  a complex system. <em>Geoforum</em>, <em>39</em>(2),
                  805&ndash;818. doi:10.1016/j.geoforum.2007.02.010
                </p>
              </li>
              <li>
                <p>
                  Department of Industrial Policy and Promotion, &amp;
                  Government of India. (2007). Industrial Corridor.
                  http://dipp.nic.in/programmes-and-schemes/infrastructure/industrial-corridors,
                  Accessed 13 January 2018
                </p>
              </li>
              <li>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  http://www.makeinindia.com/live-projects-industrial-corridor,
                  Accessed 30 April 2018
                </p>
              </li>
              <li>
                <p>
                  De Smith, M.J., Goodchild, M.F., &amp; Longley, P.A., (2007).
                  Geospatial Analysis: A Comprehensive Guide to Principles,
                  Techniques and Software Tools, second ed. Leicester, Matador.
                </p>
              </li>
              <li>
                <p>
                  European Commission. Rhine-Alpine.
                  https://ec.europa.eu/transport/themes/infrastructure/rhine-alpine_pl.
                  Accessed 5 February 2018
                </p>
              </li>
              <li>
                <p>
                  Ewing, R., &amp; Hamidi, S. (2013). Measuring Urban Sprawl and
                  Validating Sprawl Measures.{" "}
                  <em>Journal of Chemical Information and Modeling</em>,{" "}
                  <em>53</em>(9), 1689&ndash;1699.
                  doi:10.1017/CBO9781107415324.004
                </p>
              </li>
              <li>
                <p>
                  Geological Survey of India. Topographical Maps.{" "}
                  <em>Government of India</em>. www.portal.gsi.gov.in. Accessed
                  9 November 2016
                </p>
              </li>
              <li>
                <p>
                  Georg, I., Blaschke, T., &amp; Taubenb&ouml;ck, H. (2016). A
                  Global Inventory of Urban Corridors Based on Perceptions and
                  Night-Time Light Imagery.{" "}
                  <em>ISPRS International Journal of Geo-Information</em>,{" "}
                  <em>5</em>(12), 233. doi:10.3390/ijgi5120233
                </p>
              </li>
              <li>
                <p>
                  Gilbert, N. (2008). Agent-Based Models.{" "}
                  <em>SAGE Publications</em>, <em>153</em>(153), 98.
                  doi:10.4135/9781412983259
                </p>
              </li>
              <li>
                <p>
                  Gkyer, E. (2013). Understanding Landscape Structure Using
                  Landscape Metrics. In{" "}
                  <em>Advances in Landscape Architecture</em> (Murat
                  &Ouml;zya.). Turkey: InTech. doi:10.5772/55758
                </p>
              </li>
              <li>
                <p>
                  Google. (2016). Google Earth.
                  https://www.google.com/intl/en_in/earth/
                </p>
              </li>
              <li>
                <p>
                  Government of India. (2018). Bharatmala Pariyojana - A
                  Stepping Stone towards New India.
                </p>
              </li>
              <li>
                <p>
                  Grimm, N. B., Faeth, S. H., Golubiewski, N. E., Redman, C. L.,
                  Wu, J., Bai, X., et al. (2015). Global Change and the Ecology
                  of Cities Global Change and the Ecology of Cities.{" "}
                  <em>Science (New York, N.Y.)</em>, <em>319</em>(2008),
                  756&ndash;760. doi:10.1126/science.1150195
                </p>
              </li>
              <li>
                <p>
                  Grimm, N. B., Faeth, S. H., Golubiewski, N. E., Redman, C. L.,
                  Wu, J., Bai, X., &amp; Briggs, J. M. (2008). Global change and
                  the ecology of cities. <em>Science</em>.
                  doi:10.1126/science.1150195
                </p>
              </li>
              <li>
                <p>
                  Guan, Q., Wang, L., &amp; Clarke, K. C. (2005). An
                  Artificial-Neural-Network-based, Constrained CA Model for
                  Simulating Urban Growth.{" "}
                  <em>Cartography and Geographic Information Science</em>,{" "}
                  <em>32</em>(4), 369&ndash;380. doi:10.1559/152304005775194746
                </p>
              </li>
              <li>
                <p>
                  Hatfield, J. L., &amp; Prueger, J.H. (2010). Value of Using
                  Different Vegetative Indices to Quantify Agricultural Crop
                  Characteristics at Different Growth Stages under Varying
                  Management Practices. <em>Remote Sensing</em>. 2,
                  562&ndash;578.doi: 10.3390/rs2020562
                </p>
              </li>
              <li>
                <p>
                  He, J., Liu, Y., Yu, Y., Tang, W., Xiang, W., &amp; Liu, D.
                  (2013). A counterfactual scenario simulation approach for
                  assessing the impact of farmland preservation policies on
                  urban sprawl and food security in a major grain-producing area
                  of China. <em>Applied Geography</em>, <em>37</em>(1),
                  127&ndash;138. doi:10.1016/j.apgeog.2012.11.005
                </p>
              </li>
              <li>
                <p>
                  Jain, R. K., Jain, K., &amp; Rehan, A. (2017). Modeling Urban
                  Land Cover Growth Dynamics Based on Land Change Modeler (LCM)
                  Using Remote Sensing: A Case Study of Gurgaon, India.{" "}
                  <em>Advances in Computational Sciences and Technology</em>,{" "}
                  <em>10</em>(10), 2947&ndash;2961.
                  https://www.ripublication.com/acst17/acstv10n10_03.pdf
                </p>
              </li>
              <li>
                <p>
                  Jensen, J. R. (1996).{" "}
                  <em>
                    Introductory digital image processing: a remote sensing
                    perspective. Second edition
                  </em>
                  .{" "}
                  <em>
                    Introductory digital image processing: a remote sensing
                    perspective. Second edition
                  </em>
                  . doi:10.2113/gseegeosci.13.1.89
                </p>
              </li>
              <li>
                <p>
                  Ji, C. Y., Liu, Q., Sun, D., Wang, S., Lin, P., &amp; Li, X.
                  (2001). Monitoring urban expansion with remote sensing in
                  China. <em>International Journal of Remote Sensing</em>,{" "}
                  <em>22</em>
                  (8), 1441&ndash;1455. doi:10.1080/01431160117207
                </p>
              </li>
              <li>
                <p>
                  Jokar Arsanjani, J., Helbich, M., Kainz, W., Darvishi
                  Boloorani, A., Arsanjani, J. J., Helbich, M., et al. (2012).
                  Integration of logistic regression, Markov chain and cellular
                  automata models to simulate urban expansion.{" "}
                  <em>
                    International Journal of Applied Earth Observation and
                    Geoinformation
                  </em>
                  , <em>21</em>(1), 265&ndash;275. doi:10.1016/j.jag.2011.12.014
                </p>
              </li>
              <li>
                <p>
                  Lillesand, T. M., Kiefer, R. W., &amp; Chipman, J. W. (2004).{" "}
                  <em>Remote sensing and image interpretation</em>.{" "}
                  <em>Lloydia Cincinnati</em> (Vol. 3rd).
                  http://www.osti.gov/energycitations/product.biblio.jsp?osti_id=6028047
                </p>
              </li>
              <li>
                <p>
                  Macal, C. M., &amp; North, M. J. (2008). Agent-based modeling
                  and simulation: ABMS examples. In{" "}
                  <em>Proceedings - Winter Simulation Conference</em> (pp.
                  101&ndash;112). doi:10.1109/WSC.2008.4736060
                </p>
              </li>
              <li>
                <p>
                  Maes, P., (1995). Artificial life meets entertainment: life
                  like autonomous agents. <em>Communications of the ACM 38</em>{" "}
                  &nbsp;38(11), 108&ndash;114, doi: 10.1145/219717.219808
                </p>
              </li>
              <li>
                <p>
                  McGarial, K., &amp; Marks, B. (1995). FRAGSTAT: Spatial
                  pattern analysis program for quantifying landscape structure.{" "}
                  <em>
                    United States Department of Agriculture, Pacific Northwest
                    Research Station.
                  </em>
                  , (August), 120 pages.
                  doi:10.1061/(ASCE)0733-9437(2005)131:1(94) CE
                </p>
              </li>
              <li>
                <p>
                  McGrane, S. J. (2016). Impacts of urbanisation on hydrological
                  and water quality dynamics, and urban water management: a
                  review. <em>Hydrological Sciences Journal</em>, <em>61</em>
                  (13), 2295&ndash;2311. doi:10.1080/02626667.2015.1128084
                </p>
              </li>
              <li>
                <p>
                  Mena, C. F., Walsh, S. J., Frizzelle, B. G., Xiaozheng, Y.,
                  &amp; Malanson, G. P. (2011). Land use change on household
                  farms in the Ecuadorian Amazon: Design and implementation of
                  an agent-based model. <em>Applied Geography</em>, <em>31</em>
                  (1), 210&ndash;222. doi:10.1016/j.apgeog.2010.04.005
                </p>
              </li>
              <li>
                <p>
                  Miller, J. D., &amp; Hutchins, M. (2017). The impacts of
                  urbanisation and climate change on urban flooding and urban
                  water quality: A review of the evidence concerning the United
                  Kingdom. <em>Journal of Hydrology: Regional Studies</em>.
                  doi:10.1016/j.ejrh.2017.06.006
                </p>
              </li>
              <li>
                <p>
                  Milne, R. S. (1993). Singapore&rsquo;S Growth Triangle.{" "}
                  <em>The Round Table</em>, <em>82</em>(327), 291&ndash;303.
                  doi:10.1080/00358539308454164
                </p>
              </li>
              <li>
                <p>
                  Ministry of Road Tranport &amp; Highways, &amp; Government of
                  India. (2017).{" "}
                  <em>
                    Bharathmala Pariyojana: A stepping stone towards &ldquo;New
                    India.&rdquo;
                  </em>{" "}
                  http://morth.nic.in/BharatMala/index.html#
                </p>
              </li>
              <li>
                <p>
                  Mohammady, S., Delavar, M. R., &amp; Pahlavani, P. (2014).
                  URBAN GROWTH MODELING USING AN ARTIFICIAL NEURAL NETWORK A
                  CASE STUDY OF SANANDAJ CITY, IRAN.{" "}
                  <em>
                    ISPRS - International Archives of the Photogrammetry, Remote
                    Sensing and Spatial Information Sciences
                  </em>
                  , <em>XL</em>-<em>2/W3</em>, 203&ndash;208.
                  doi:10.5194/isprsarchives-XL-2-W3-203-2014
                </p>
              </li>
              <li>
                <p>
                  Mumbai-Pune Expressway, India. (2018).{" "}
                  <em>Road Traffic Technology</em>.
                  https://www.roadtraffic-technology.com/projects/mumbai/.
                  Accessed 24 March 2018
                </p>
              </li>
              <li>
                <p>
                  National Remote Sensing Centre. (2016). Bhuvan.{" "}
                  <em>
                    Indian Space Research Organisation, Government of India
                  </em>
                  . http://bhuvan.nrsc.gov.in/
                </p>
              </li>
              <li>
                <p>
                  view.{" "}
                  <em>Annals of the Association of American Geographers</em>,{" "}
                  <em>93</em>(2), 314&ndash;337. doi:10.1111/1467-8306.9302004
                </p>
              </li>
              <li>
                <p>
                  Pascal, J. P. (1982). <em>Forest Map of South India</em>.{" "}
                  <em>French Insititute of Pondicherry</em>,
                  http://www.ifpindia.org, assessed 23 June 2017.
                </p>
              </li>
              <li>
                <p>
                  Pune Municipal Corporation. (2012). Pune City Development Plan
                  2041.
                  https://pmc.gov.in/sites/default/files/project-glimpses/Draft_City_Development_Plan_for_Pune_City_2041_Vol-1.pdf.
                  Accessed 29 April 2018
                </p>
              </li>
              <li>
                <p>
                  Ramachandra, T. V., Bharath, H. A., &amp; Vinay, S. (2013).
                  Land use Land Cover Dynamics in a rapidly urbanizing
                  Landscape. <em>SCIT</em>, <em>13</em>, 1&ndash;12. &nbsp;
                </p>
              </li>
              <li>
                <p>
                  Ramachandra, T. V., Bharath, S., &amp; Bharath, H. A. (2012).
                  Peri-Urban to Urban Landscape Patterns Elucidation through
                  Spatial Metrics.{" "}
                  <em>
                    International Journal of Engineering Research and
                    Development
                  </em>
                  , <em>2</em>(12), 58&ndash;81.
                </p>
              </li>
              <li>
                <p>
                  Ramachandra, T. V., &amp; Bharath, H. A. (2012). Land use
                  dynamics at padubidri, udupi district with the implementation
                  of large scale thermal power project.{" "}
                  <em>
                    International Journal of Earth Sciences and Engineering
                  </em>
                  , <em>5</em>(3), 409&ndash;417.
                </p>
              </li>
              <li>
                <p>
                  Ramachandra, T. V., Bharath, H. A., &amp; Durgappa, D. S.
                  (2012). Insights to urban dynamics through landscape spatial
                  pattern analysis.{" "}
                  <em>
                    International Journal of Applied Earth Observation and
                    Geoinformation
                  </em>
                  , <em>18</em>(1), 329&ndash;343. doi:10.1016/j.jag.2012.03.005
                </p>
              </li>
              <li>
                <p>
                  Ramachandra, T. V., Bharath, H. A., Gouri, K., &amp; Vinay, S.
                  (2017). Green Spaces in Bengaluru: Quantification through
                  Geospatial Techniques. <em>Indian Forester</em>, <em>143</em>
                  (4), 307&ndash;320.
                </p>
              </li>
              <li>
                <p>
                  Ramachandra, T. V., Bharath, S., &amp; Bharath, H. A. (2014).
                  Spatio-temporal dynamics along the terrain gradient of diverse
                  landscape.{" "}
                  <em>
                    Journal of Environmental Engineering and Landscape
                    Management
                  </em>
                  , <em>22</em>(1), 50&ndash;63.
                  doi:10.3846/16486897.2013.808639
                </p>
              </li>
              <li>
                <p>
                  Ramachandra, T. V, Gouri, K., Bharath, H. A., Settur, B.,
                  Vinay, S., &amp; Bhat, H. R. (2016).{" "}
                  <em>
                    Mini forest at Indian Institute of Science: The Success
                    Model for Rejuvenating Ecology and Hydrology in Rapidly
                    Urbanizing Landscapes
                  </em>
                  . (E. T. R. 110 Sahyadri Conservation Series 58, Ed.).
                  Bangalore 560012.
                </p>
              </li>
              <li>
                <p>
                  Ramachandta, T. V, Bharath, H. A., Vinay, S., Joshi, N. V.,
                  Kumar, U., Venugopal Rao, K., et al. (2013). Modelling Urban
                  Revolution in Greater Bangalore, India. In{" "}
                  <em>
                    30th Annual In-House Symposium on Space Science and
                    Technology ISRO-IISc Space Technology Cell
                  </em>{" "}
                  (p. 5). Bangalore 560 012: ISRO-IISc Space Technology Cell,
                  Indian Institute of Scienc.
                </p>
              </li>
              <li>
                <p>
                  Sabin, F. (1997).{" "}
                  <em>Remote Sensing: Principles and Interpretation</em>.{" "}
                  <em>Waveland Press, Inc</em>. Los Angeles: Remote Sensing
                  Enterprises, Incorporated and University of California, Los
                  Angeles.
                </p>
              </li>
              <li>
                <p>
                  Sang, L., Zhang, C., Yang, J., Zhu, D., &amp; Yun, W. (2011).
                  Simulation of land use spatial pattern of towns and villages
                  based on CA&ndash;Markov model.{" "}
                  <em>Mathematical and Computer Modelling</em>, <em>54</em>
                  (3&ndash;4), 938&ndash;943. doi:10.1016/j.mcm.2010.11.019
                </p>
              </li>
              <li>
                <p>
                  Siddayao, G. P., Valdez, S. E., &amp; Fernandez, P. L. (2014).
                  Analytic Hierarchy Process (AHP) in Spatial Modeling for
                  Floodplain Risk Assessment.{" "}
                  <em>
                    International Journal of Machine Learning and Computing
                  </em>
                  , <em>4</em>(5), 450&ndash;457. doi:10.7763/IJMLC.2014.V4.453
                </p>
              </li>
              <li>
                <p>
                  Smith, S. L. D. (1997). The Indonesia‐Malaysia‐Singapore
                  growth triangle: A political and economic equation.{" "}
                  <em>Australian Journal of International Affairs</em>,{" "}
                  <em>51</em>(3), 369&ndash;382. doi:10.1080/10357719708445224
                </p>
              </li>
              <li>
                <p>
                  Survey of India, Topographical Maps.{" "}
                  <em>Government of India</em>, http://surveyofindia.gov.in
                  accessed on 28 April 2018.
                </p>
              </li>
              <li>
                <p>
                  Taubenb&ouml;ck, H., Esch, T., Felbier, A., Wiesner, M., Roth,
                  A., &amp; Dech, S. (2012). Monitoring urbanization in mega
                  cities from space. <em>Remote Sensing of Environment</em>,{" "}
                  <em>117</em>, 162&ndash;176. doi:10.1016/j.rse.2011.09.015
                </p>
              </li>
              <li>
                <p>
                  Taubenb&ouml;ck, H., Wegmann, M., Roth, A., Mehl, H., &amp;
                  Dech, S. (2009). Urbanization in India - Spatiotemporal
                  analysis using remote sensing data.{" "}
                  <em>Computers, Environment and Urban Systems</em>, <em>33</em>
                  (3), 179&ndash;188. doi:10.1016/j.compenvurbsys.2008.09.003
                </p>
              </li>
              <li>
                <p>
                  Trans-European Transport Network. (2018). TENtec: Mobility and
                  Transport. https://ec.europa.eu/transport/media_en. Accessed 5
                  February 2018
                </p>
              </li>
              <li>
                <p>
                  UDRI. (2014). Development Plan for Mumbai.
                  http://www.mumbaidp24seven.in/. Accessed 29 April 2018
                </p>
              </li>
              <li>
                <p>
                  United States Geological Survey. (2015a). Earthexplorer.{" "}
                  <em>United States Geological Survey</em>.
                  https://earthexplorer.usgs.gov;
                  http://landcover.usgs.gov/pdf/anderson.pdf, Accessed 3
                  December 2018
                </p>
              </li>
              <li>
                <p>
                  United States Geological Survey. (2015b). GloVis.
                  https://glovis.usgs.gov/. Accessed &nbsp;3 December 2018
                </p>
              </li>
              <li>
                <p>
                  Vinay, S., Bharath, S., Bharath, H. A., &amp; Ramachandra, T.
                  V. (2013). Hydrologic model with landscape dynamics for
                  drought monitoring. In{" "}
                  <em>
                    Joint International Workshop of ISPRS VIII/1 and WG IV/4 on
                    Geospatial Data for Disaster and Risk Reduction
                  </em>
                  . Hyderabad.
                </p>
              </li>
              <li>
                <p>
                  Wassenaar, T., Gerber, P., Verburg, P. H., Rosales, M.,
                  Ibrahim, M., &amp; Steinfeld, H. (2007). Projecting land use
                  changes in the Neotropics: The geography of pasture expansion
                  into forest. <em>Global Environmental Change</em>, <em>17</em>
                  (1), 86&ndash;104. doi:10.1016/j.gloenvcha.2006.03.007
                </p>
              </li>
              <li>
                <p>
                  Wooldridge, M., &amp; Jennings, N.R., 1995. Intelligent
                  agents: theory and practice.{" "}
                  <em>The Knowledge Engineering Review </em>
                  10 (2), 115&ndash;152. doi: 10.1017/S0269888900008122Yang, L.,
                  Fu, C., &amp; Chen, H. (2017). Design and Simulation of Gannan
                  Forest Change Based on CA-Markov Model.{" "}
                  <em>
                    International Journal of Future Generation Communication and
                    Networking
                  </em>
                  , <em>10</em>, 21&ndash;30.
                </p>
              </li>
            </ol>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
